module.exports = __webpack_public_path__ + "static/media/collection-banner.fca04667.jpg";